import React from 'react'
import Routes from '@brainstud/react-tbl/themes/pgw/v1/routes'
import { PageFooter, Button, ButtonsGroup, PageProgress } from '@brainstud/react-tbl/themes/pgw/v1/components/library'
import { translate } from '@brainstud/react-tbl/themes/pgw/v1/translations'

const PagePageFooter = props => (
  <PageFooter style={props.style}>
    <div className="Page-footer-left">
      <Button outline to={Routes.to('home')} icon="home" />
    </div>

    <div className="Page-footer-right">
      <PageProgress
        current={props.currentProgress}
        total={props.totalProgress}
      />
      <ButtonsGroup>
        <Button square onClick={props.handleBack} label={translate('app.back')} icon="arrow-left" iconPos="left" />
        <Button primary square onClick={props.handleNext} label={translate('app.next')} icon="arrow-right" iconPos="right" />
      </ButtonsGroup>
    </div>
  </PageFooter>
)

PagePageFooter.defaultProps = {
  currentProgress: 1,
  totalProgress: 1,
  handleBack: () => { },
  handleNext: () => { },
}

export default PagePageFooter
